import React from 'react';
import { Link } from 'react-router-dom';
import './Breadcrumbs.css';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <nav className="breadcrumbs" aria-label="Хлебные крошки">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const content = isLast || !item.to ? (
          <span className="breadcrumbs-item breadcrumbs-item-current">{item.label}</span>
        ) : (
          <Link
            to={item.to}
            className="breadcrumbs-link"
          >
            {item.label}
          </Link>
        );

        return (
          <span key={`${item.to || item.label}-${index}`} className="breadcrumbs-segment">
            {index > 0 && <span className="breadcrumbs-separator">/</span>}
            {content}
          </span>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;


